export const cleanPhoneNumber = (phone: string): string => {
  return phone.replace(/[^\d]/g, '');
};
